import { render, staticRenderFns } from "./AppuntamentiConferma.vue?vue&type=template&id=ab7ccfb6"
import script from "./AppuntamentiConferma.vue?vue&type=script&lang=js"
export * from "./AppuntamentiConferma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports